import { EQUIPMENT_GLYPH_OF, EQUIPMENT_GLYPH_PATHS } from "../lib/equipmentGlyphs";
import { glyphOf, iconIsMask, iconUrl } from "../lib/equipmentLibrary";

/* THE PHONE'S EQUIPMENT ICON, ON THE WEB (his point 6, 2026-09-23: *"why not use the icons we had
 * for the equipment? So in each chip we got the icon and the name of it"*). The drawings are the
 * phone's own — `equipmentGlyphs.ts` is GENERATED from `EquipmentGlyph.swift` — and drawn the way
 * the phone draws them: ink in the current text colour, the one accent (the part you grip or load)
 * in the accent red, and a stroke that stays 1.25 px whatever the size (the phone divides its line
 * width by the scale; `non-scaling-stroke` is the same idea). A key with no drawing draws nothing
 * rather than a stand-in — the phone's own rule: an icon that is not the thing is worse than none. */
export function EquipmentIcon({ equipmentKey, size = 16 }: { equipmentKey: string; size?: number }) {
  const kind = EQUIPMENT_GLYPH_OF[equipmentKey];
  const d = kind === undefined ? undefined : EQUIPMENT_GLYPH_PATHS[kind];
  if (d === undefined) return null;
  const line = { fill: "none", strokeWidth: 1.25, strokeLinecap: "round" as const,
                 strokeLinejoin: "round" as const, vectorEffect: "non-scaling-stroke" as const };
  return (
    <svg className="equipment-icon" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      {d.f !== "" && <path d={d.f} fill="currentColor" />}
      {d.s !== "" && <path d={d.s} stroke="currentColor" {...line} />}
      {d.af !== "" && <path d={d.af} fill="var(--ht-accent)" />}
      {d.as !== "" && <path d={d.as} stroke="var(--ht-accent)" {...line} />}
    </svg>
  );
}

/* A PIECE'S ICON AS THE COACH SET IT (W62 step C) — the three shapes of `icon_path`, the same
 * contract the phone reads (`CoachEquipmentDirectory.swift`): `glyph:<key>` draws one of OUR drawings;
 * an upload named `…-mask.png` is a SHAPE, painted in the current ink through a CSS mask so it sits in
 * the set in both themes; any other upload is a picture drawn as itself. No icon → the app's own
 * drawing for the key, or nothing for a piece of his own that has none. */
export function PieceIcon({ equipmentKey, iconPath, size = 16 }: {
  equipmentKey: string; iconPath: string | null | undefined; size?: number;
}) {
  const glyph = glyphOf(iconPath);
  if (glyph !== null) return <EquipmentIcon equipmentKey={glyph} size={size} />;
  const url = iconUrl(iconPath);
  if (url !== null && iconPath !== null && iconPath !== undefined) {
    return iconIsMask(iconPath)
      ? <span className="equipment-icon equipment-icon-mask" aria-hidden="true"
              style={{ width: size, height: size, maskImage: `url("${url}")`, WebkitMaskImage: `url("${url}")` }} />
      : <img className="equipment-icon equipment-icon-photo" src={url} width={size} height={size} alt="" />;
  }
  return <EquipmentIcon equipmentKey={equipmentKey} size={size} />;
}
